import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "auth auth--bg-second" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "auth__logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "auth__logo auth__logo--flying img",
    src: "/static/app/auth-form-logo.svg",
    alt: "hq vpn logo",
    title: ""
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "auth__white-bg" }, null, -1)
const _hoisted_4 = { class: "g-container g-container--fit_main-width g-container--space_special-md relative relative--align_center" }
const _hoisted_5 = { class: "g-row g-row--justify_center g-row--justify_start-xl g-row--appearance_spaced g-row--space_md" }
const _hoisted_6 = { class: "g-cell g-cols g-cols--12 g-cols--narrow-sm" }
const _hoisted_7 = { class: "auth-form auth-form--bg_none auth-form--max-width_sm" }
const _hoisted_8 = { class: "auth-form__title" }
const _hoisted_9 = { class: "auth-form__wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "g-row g-row--appearance_spaced g-row--space_md g-row--space_xl-xl g-row--justify_center g-row--align_center"
}
const _hoisted_11 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_12 = { class: "ds-caption ds-caption--size_2md ds-caption--size_lg-xl ds-caption--color_dark-blue ds-caption--bold ds-caption--line-h_xl" }
const _hoisted_13 = { class: "g-row g-row--appearance_spaced g-row--space_md g-row--space_xl-xl g-row--justify_center g-row--align_center" }
const _hoisted_14 = { class: "error-label" }
const _hoisted_15 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_16 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_17 = {
  key: 0,
  class: "hq-btn hq-btn--blue hq-btn--centered hq-btn--shadowed hq-btn--auth-style hq-btn--full_width hq-btn--full_height-xl",
  type: "submit"
}
const _hoisted_18 = { class: "hq-btn__text ds-caption ds-caption--size_2md ds-caption--color_white ds-caption--bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_vee_form = _resolveComponent("vee-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            ($setup.load)
              ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _createElementVNode("div", _hoisted_9, [
              ($setup.formIsSended)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, _toDisplayString($setup.$t("На ваш email были отправлены иснтрукции по восстановлению доступа к вашей учетной записи")), 1)
                    ])
                  ]))
                : (_openBlock(), _createBlock(_component_vee_form, {
                    key: 1,
                    class: "hq-form",
                    onSubmit: $setup.request
                  }, {
                    default: _withCtx(({ errors }) => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
                          default: _withCtx(({ message }) => [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(message), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_d_control_input, {
                            class: "input-main-gray auth-style auth-width",
                            rules: "required|email",
                            name: "email",
                            type: "email",
                            staticLabel: $setup.$t("Введите ваш email"),
                            modelValue: $setup.email,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event))
                          }, null, 8, ["staticLabel", "modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          (!_ctx.timeIsOver)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_17, [
                                _createElementVNode("p", _hoisted_18, _toDisplayString($setup.$t("Отправить")), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }))
            ])
          ])
        ])
      ])
    ])
  ]))
}